var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 862 549",
    style: {
      enableBackground: "new 0 0 862 549"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:none;stroke:url(#SVGID_4_);stroke-width:45.3171;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_5_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.6373,
    y1: 274.3888,
    x2: 800,
    y2: 274.3888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001260747,
    style: {
      stopColor: "#00D4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    style: {
      stopColor: "#00AA06"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M655.1,107.9L276.8,52.1L66.6,209.1l55.7,205.8l377.1,81.8L800,274.3L655.1,107.9z M316,248.7l-9.1,36.5h-77.8 l-9.1,36.5h86.9l-9.1,36.5H171.3l44.7-179.5H338l-9.1,36.5h-82.4l-8.3,33.5H316z M473.6,321.7l-9.1,36.5H338l44.7-179.5h121.9 l-9.1,36.5h-82.4l-8.3,33.5h77.8l-9.1,36.5h-77.8l-9.1,36.5H473.6z M633.2,303.7c-2.5,10-6.5,18.7-12.1,26.1 c-5.6,7.4-12.1,13.6-19.7,18.5c-7.6,4.9-15.8,8.5-24.8,10.9s-18.1,3.5-27.4,3.5c-11.7,0-22-1.8-31.1-5.3 c-9.1-3.5-16.9-9.3-23.6-17.2l35.8-30.9c2.7,5.4,6.8,9.6,12.2,12.5c5.4,3,11.4,4.4,18,4.4c3.2,0,6.6-0.4,10-1.1 c3.5-0.8,6.7-1.9,9.7-3.4c3-1.5,5.6-3.5,7.8-5.8c2.2-2.4,3.7-5.2,4.5-8.4c1.3-5.4,0.3-9.7-3-12.8c-3.4-3.1-7.9-5.8-13.6-8 c-5.7-2.2-11.9-4.4-18.6-6.6c-6.7-2.2-12.7-5.2-18.1-8.9c-5.3-3.7-9.3-8.6-11.9-14.7c-2.6-6.1-2.7-14.1-0.2-24.1 c2.4-9.6,6.4-18.1,12-25.3c5.6-7.3,12.2-13.3,19.8-18.2c7.6-4.9,15.8-8.6,24.7-11c8.9-2.4,17.7-3.7,26.5-3.7 c10.1,0,19.6,1.4,28.3,4.3c8.7,2.9,16.1,7.7,22,14.4L626,222.6c-2.2-4.1-5.8-7.1-10.8-9c-5-1.9-10-2.9-14.9-2.9 c-2.9,0-5.9,0.3-9.1,1c-3.2,0.7-6.3,1.7-9.4,3.2c-3.1,1.4-5.7,3.3-8,5.7c-2.3,2.4-3.8,5.2-4.7,8.6c-1.3,5.4-0.4,9.5,3,12.4 c3.3,2.9,7.8,5.3,13.5,7.4c5.7,2,11.8,4.1,18.4,6.1c6.6,2,12.5,4.9,17.7,8.6c5.2,3.7,9.1,8.7,11.6,15 C635.8,284.8,635.8,293.2,633.2,303.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a5eadbb980c932a4119021542b9399d5.svg";
export { ForwardRef as ReactComponent };